<template>
	<div id="app">
		<!-- ここで現在のルートに応じたコンポーネントが表示される -->
		<!-- index.js から初回に読み込むコンポーネントを判断 -->
		<router-view></router-view>
	</div>
</template>

<script>
import { onMounted, onUnmounted, watch } from "vue";
import { useAuthStore } from "@/stores/authStore";
import { storeToRefs } from "pinia";
import { useInactivityStore } from "@/stores/inactivityStore";
import { logout } from "@/utils/logout";

export default {
	name: "App",
	setup() {
		const authStore = useAuthStore();
		const inactivityStore = useInactivityStore();
		const { isAuthenticated } = storeToRefs(authStore);

		// テスト用: 60秒、デバッグON
		// 本番: limitMs を 3_600_000、debug を false へ
		inactivityStore.configure({
			limitMs: 3_600_000, // ← 本番は 3_600_000
			debug: false, // ← テスト時のみ true
		});
		// 満了時のログアウト処理
		inactivityStore.setLogoutFn(async () => {
			await logout();
		});

		onMounted(() => {
			watch(
				isAuthenticated,
				(authed) => {
					if (authed) {
						inactivityStore.attach();
						inactivityStore.start();
					} else {
						inactivityStore.detach();
					}
				},
				{ immediate: true }
			);
		});

		onUnmounted(() => inactivityStore.detach());
	},
};
</script>

<style>
/* 必要なスタイルをここに追加 */
</style>
